const features = [
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20181029_162114_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20181029_162114_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20181029_162114_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.67134736107958,
            45.92622515070822
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.74102333037588,
            45.702617053615555
          ],
          [
            -84.7129058539529,
            45.7932116274391
          ],
          [
            -84.67134736107958,
            45.92622515070822
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20181029_162114_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-10-29T16:21:14Z",
      "anomalous_pixels": 0.22,
      "black_fill": 0.44,
      "catalog_id": "37770806",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-10-30T11:33:12Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "37770726",
      "sun_azimuth": 162.90795,
      "sun_elevation": 29.19911,
      "updated": "2018-10-30T11:33:12Z",
      "usable_data": 0.78,
      "view_angle": 10.36098
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660222_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660222_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660222_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180922_162551_1660222_RapidEye-4",
    "properties": {
      "acquired": "2018-09-22T16:25:51Z",
      "anomalous_pixels": 0.37,
      "black_fill": 0,
      "catalog_id": "37437633",
      "cloud_cover": 0.37,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-09-23T10:25:18Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "37437529",
      "sun_azimuth": 157.5802,
      "sun_elevation": 42.2892,
      "updated": "2018-09-23T10:25:18Z",
      "usable_data": 0.63,
      "view_angle": 10.30177
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660221_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660221_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180922_162551_1660221_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180922_162551_1660221_RapidEye-4",
    "properties": {
      "acquired": "2018-09-22T16:25:51Z",
      "anomalous_pixels": 0.15,
      "black_fill": 0,
      "catalog_id": "37437632",
      "cloud_cover": 0.15,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-09-23T10:25:18Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "37437529",
      "sun_azimuth": 157.18343,
      "sun_elevation": 42.20136,
      "updated": "2018-09-23T10:25:18Z",
      "usable_data": 0.85,
      "view_angle": 10.30177
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180906_163656_1660222_RapidEye-2",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180906_163656_1660222_RapidEye-2/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180906_163656_1660222_RapidEye-2/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.66895535261759,
            45.92617652734112
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.74440403707855,
            45.702685514089175
          ],
          [
            -84.6758680346007,
            45.9058177429089
          ],
          [
            -84.66895535261759,
            45.92617652734112
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180906_163656_1660222_RapidEye-2",
    "properties": {
      "acquired": "2018-09-06T16:36:56Z",
      "anomalous_pixels": 0.22,
      "black_fill": 0.44,
      "catalog_id": "37251433",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-09-07T11:23:14Z",
      "rows": 5000,
      "satellite_id": "RapidEye-2",
      "strip_id": "37251350",
      "sun_azimuth": 157.08632,
      "sun_elevation": 48.55503,
      "updated": "2018-09-07T11:23:14Z",
      "usable_data": 0.78,
      "view_angle": 0.38992
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165308_1660221_RapidEye-2",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165308_1660221_RapidEye-2/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165308_1660221_RapidEye-2/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8574601941243,
            45.70493264797212
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.83304359902235,
            45.76486380023258
          ],
          [
            -84.8574601941243,
            45.70493264797212
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180814_165308_1660221_RapidEye-2",
    "properties": {
      "acquired": "2018-08-14T16:53:08Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0.01,
      "catalog_id": "37023066",
      "cloud_cover": 0.01,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-08-15T09:26:17Z",
      "rows": 5000,
      "satellite_id": "RapidEye-2",
      "strip_id": "37022955",
      "sun_azimuth": 156.79408,
      "sun_elevation": 56.76701,
      "updated": "2018-08-15T09:26:17Z",
      "usable_data": 0.98,
      "view_angle": -16.13637
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165307_1660222_RapidEye-2",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165307_1660222_RapidEye-2/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180814_165307_1660222_RapidEye-2/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84725056249549,
            45.72999244787929
          ],
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.76627241399808,
            45.92815473238358
          ],
          [
            -84.7964383423858,
            45.8547123315228
          ],
          [
            -84.84725056249549,
            45.72999244787929
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180814_165307_1660222_RapidEye-2",
    "properties": {
      "acquired": "2018-08-14T16:53:07Z",
      "anomalous_pixels": 0.9,
      "black_fill": 0.91,
      "catalog_id": "37023068",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-08-15T09:26:17Z",
      "rows": 5000,
      "satellite_id": "RapidEye-2",
      "strip_id": "37022955",
      "sun_azimuth": 157.31037,
      "sun_elevation": 56.8558,
      "updated": "2018-08-15T09:26:17Z",
      "usable_data": 0.1,
      "view_angle": -16.13637
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180805_163517_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-08-05T16:35:17Z",
      "anomalous_pixels": 0.09,
      "black_fill": 0,
      "catalog_id": "36940955",
      "cloud_cover": 0.09,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-08-07T16:54:50Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36940913",
      "sun_azimuth": 147.60557,
      "sun_elevation": 57.78401,
      "updated": "2018-08-07T16:54:50Z",
      "usable_data": 0.91,
      "view_angle": -2.96334
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180805_163517_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.88774952105744,
            45.93047584839236
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -84.96586767145061,
            45.706834985048225
          ],
          [
            -84.9301388050694,
            45.8095534097767
          ],
          [
            -84.88774952105744,
            45.93047584839236
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180805_163517_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-08-05T16:35:17Z",
      "anomalous_pixels": 0.77,
      "black_fill": 0.7,
      "catalog_id": "36940954",
      "cloud_cover": 0.07,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-08-07T16:54:49Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36940913",
      "sun_azimuth": 147.1061,
      "sun_elevation": 57.66355,
      "updated": "2018-08-07T16:54:49Z",
      "usable_data": 0.23,
      "view_angle": -2.96334
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163603_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163603_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163603_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180717_163603_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-07-17T16:36:03Z",
      "anomalous_pixels": 0.09,
      "black_fill": 0,
      "catalog_id": "36721326",
      "cloud_cover": 0.09,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-07-18T09:17:26Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36721234",
      "sun_azimuth": 143.79922,
      "sun_elevation": 61.59459,
      "updated": "2018-07-18T09:17:26Z",
      "usable_data": 0.91,
      "view_angle": 3.63853
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163602_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163602_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180717_163602_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8224828488212,
            45.70426663688432
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.74450641177835,
            45.927712285656
          ],
          [
            -84.7782206799437,
            45.8315258499296
          ],
          [
            -84.8224828488212,
            45.70426663688432
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180717_163602_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-07-17T16:36:02Z",
      "anomalous_pixels": 0.92,
      "black_fill": 0.82,
      "catalog_id": "36721328",
      "cloud_cover": 0.1,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-07-18T09:17:26Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36721234",
      "sun_azimuth": 144.33345,
      "sun_elevation": 61.72505,
      "updated": "2018-07-18T09:17:26Z",
      "usable_data": 0.08,
      "view_angle": 3.63853
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52174868181073,
            45.8244240061718
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.84176712701927,
            45.872000448354704
          ],
          [
            -84.7058579762623,
            45.8518758801046
          ],
          [
            -84.52174868181073,
            45.8244240061718
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180703_164140_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-07-03T16:41:40Z",
      "anomalous_pixels": 0.35,
      "black_fill": 0.35,
      "catalog_id": "36589495",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-07-04T09:35:56Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36589383",
      "sun_azimuth": 146.08822,
      "sun_elevation": 64.10233,
      "updated": "2018-07-04T09:35:56Z",
      "usable_data": 0.65,
      "view_angle": -9.69204
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180703_164140_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82895569047346,
            45.87010341178497
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.10132813613139,
            45.70921204861122
          ],
          [
            -85.0310289680145,
            45.9000251458459
          ],
          [
            -84.82895569047346,
            45.87010341178497
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180703_164140_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-07-03T16:41:40Z",
      "anomalous_pixels": 0.42,
      "black_fill": 0.42,
      "catalog_id": "36589493",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-07-04T09:35:55Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36589383",
      "sun_azimuth": 145.5125,
      "sun_elevation": 63.97716,
      "updated": "2018-07-04T09:35:55Z",
      "usable_data": 0.58,
      "view_angle": -9.69204
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0023",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0023/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0023/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80982039115717,
            45.804944224823664
          ],
          [
            -84.81290619602444,
            45.79581350756416
          ],
          [
            -84.78173983930047,
            45.789685877105775
          ],
          [
            -84.77863720495284,
            45.7987974356222
          ],
          [
            -84.80982039115717,
            45.804944224823664
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0023",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.1,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:32Z",
      "quality_category": "standard",
      "satellite_azimuth": 135.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:22Z",
      "view_angle": 15.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0022",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0022/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0022/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80639160179933,
            45.81163803854415
          ],
          [
            -84.80954071964155,
            45.80288667158736
          ],
          [
            -84.7791251591496,
            45.797204775389936
          ],
          [
            -84.7760859673823,
            45.805993458841954
          ],
          [
            -84.80639160179933,
            45.81163803854415
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0022",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.17,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:31Z",
      "quality_category": "standard",
      "satellite_azimuth": 132.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:21Z",
      "view_angle": 15.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0021",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0021/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0021/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84086028923647,
            45.79732650840903
          ],
          [
            -84.84393676963225,
            45.78829377997338
          ],
          [
            -84.81287282966358,
            45.78252761293213
          ],
          [
            -84.8097920632727,
            45.79155043323955
          ],
          [
            -84.84086028923647,
            45.79732650840903
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0021",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:30Z",
      "quality_category": "standard",
      "satellite_azimuth": 128.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50.1,
      "updated": "2018-06-22T19:03:20Z",
      "view_angle": 14.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0021",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0021/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0021/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80413716246215,
            45.82019949479909
          ],
          [
            -84.80723345051639,
            45.811177161492296
          ],
          [
            -84.77643073518686,
            45.805415117748296
          ],
          [
            -84.77333021415971,
            45.814427544409604
          ],
          [
            -84.80413716246215,
            45.82019949479909
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0021",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.08,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:30Z",
      "quality_category": "standard",
      "satellite_azimuth": 130.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:19Z",
      "view_angle": 14.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0020",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0020/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0020/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83817768312664,
            45.80513348589189
          ],
          [
            -84.841127878868,
            45.796062449122175
          ],
          [
            -84.8101575349215,
            45.79043233553552
          ],
          [
            -84.80720302409892,
            45.79949350026244
          ],
          [
            -84.83817768312664,
            45.80513348589189
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0020",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:29Z",
      "quality_category": "standard",
      "satellite_azimuth": 126.2,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50.1,
      "updated": "2018-06-22T19:03:19Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0020",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0020/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0020/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8018903703753,
            45.82822099544666
          ],
          [
            -84.80487280461935,
            45.819169542441195
          ],
          [
            -84.7741634942693,
            45.81354370543908
          ],
          [
            -84.77117716336727,
            45.82257629057837
          ],
          [
            -84.8018903703753,
            45.82822099544666
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0020",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.14,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:29Z",
      "quality_category": "standard",
      "satellite_azimuth": 127.9,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:18Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0019",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0019/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0019/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83621557556268,
            45.81326007227219
          ],
          [
            -84.83910296143968,
            45.80416990656524
          ],
          [
            -84.80779405780169,
            45.798532756283144
          ],
          [
            -84.80491655842705,
            45.8075773281589
          ],
          [
            -84.83621557556268,
            45.81326007227219
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0019",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:28Z",
      "quality_category": "standard",
      "satellite_azimuth": 123.6,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50.1,
      "updated": "2018-06-22T19:03:17Z",
      "view_angle": 14.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0019",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0019/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0019/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80022968683276,
            45.83614043352332
          ],
          [
            -84.80328512090212,
            45.827079740707
          ],
          [
            -84.77183346480913,
            45.821398801848574
          ],
          [
            -84.76888164941911,
            45.830420331019276
          ],
          [
            -84.80022968683276,
            45.83614043352332
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0019",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.2,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:28Z",
      "quality_category": "standard",
      "satellite_azimuth": 125.2,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:17Z",
      "view_angle": 14.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0020",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0020/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0020/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78437584172669,
            45.79559603693837
          ],
          [
            -84.78740193995544,
            45.78658408744383
          ],
          [
            -84.7563132863045,
            45.78086523977861
          ],
          [
            -84.75327458381868,
            45.789886263186304
          ],
          [
            -84.78437584172669,
            45.79559603693837
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0020",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.56,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:28Z",
      "quality_category": "standard",
      "satellite_azimuth": 127,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:18Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0018",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0018/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0018/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83380440941771,
            45.821000065452935
          ],
          [
            -84.83674233726508,
            45.811955931988145
          ],
          [
            -84.80540081297991,
            45.8063895245284
          ],
          [
            -84.80248495088246,
            45.81540628559333
          ],
          [
            -84.83380440941771,
            45.821000065452935
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0018",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.06,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:27Z",
      "quality_category": "standard",
      "satellite_azimuth": 120.9,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:16Z",
      "view_angle": 14
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0018",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0018/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0018/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79753355997087,
            45.84389378553278
          ],
          [
            -84.80056198496025,
            45.83488775790027
          ],
          [
            -84.76920092807296,
            45.82928724684796
          ],
          [
            -84.76623647910803,
            45.83826386264867
          ],
          [
            -84.79753355997087,
            45.84389378553278
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0018",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.17,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:27Z",
      "quality_category": "standard",
      "satellite_azimuth": 122.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:16Z",
      "view_angle": 14
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0019",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0019/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0019/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78177939365881,
            45.80362057313425
          ],
          [
            -84.78480187856542,
            45.79463216474506
          ],
          [
            -84.75373241072936,
            45.789027566911706
          ],
          [
            -84.75066350455629,
            45.79801260468462
          ],
          [
            -84.78177939365881,
            45.80362057313425
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0019",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.07,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:27Z",
      "quality_category": "standard",
      "satellite_azimuth": 124.3,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:16Z",
      "view_angle": 14.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83122423572908,
            45.82876379251853
          ],
          [
            -84.83417519973314,
            45.81973798405227
          ],
          [
            -84.80283894140632,
            45.81426099166014
          ],
          [
            -84.7999100542444,
            45.823259424932075
          ],
          [
            -84.83122423572908,
            45.82876379251853
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0017",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.05,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:26Z",
      "quality_category": "standard",
      "satellite_azimuth": 118.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:15Z",
      "view_angle": 13.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0018",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0018/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0018/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77912139957262,
            45.811505231096895
          ],
          [
            -84.78215524985723,
            45.802512239895236
          ],
          [
            -84.75104308292543,
            45.79700348412045
          ],
          [
            -84.74794896416486,
            45.80599588133876
          ],
          [
            -84.77912139957262,
            45.811505231096895
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0018",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.09,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:26Z",
      "quality_category": "standard",
      "satellite_azimuth": 121.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:15Z",
      "view_angle": 14
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82891147223312,
            45.83632609337692
          ],
          [
            -84.83173868910343,
            45.82732312942015
          ],
          [
            -84.80101957903791,
            45.822035343065345
          ],
          [
            -84.79795145227173,
            45.831006004914755
          ],
          [
            -84.82891147223312,
            45.83632609337692
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0016",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.07,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:25Z",
      "quality_category": "standard",
      "satellite_azimuth": 115.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:14Z",
      "view_angle": 13.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79483399726354,
            45.85168730694035
          ],
          [
            -84.7978669416451,
            45.84272471215996
          ],
          [
            -84.76656405447785,
            45.83720540912078
          ],
          [
            -84.7635824048238,
            45.84615035979497
          ],
          [
            -84.79483399726354,
            45.85168730694035
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0017",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.01,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:25Z",
      "quality_category": "standard",
      "satellite_azimuth": 119.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:14Z",
      "view_angle": 13.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77647793717895,
            45.81948367919896
          ],
          [
            -84.77951457732729,
            45.81045454162021
          ],
          [
            -84.74834685527753,
            45.80503844036596
          ],
          [
            -84.74522161508355,
            45.814060338843866
          ],
          [
            -84.77647793717895,
            45.81948367919896
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0017",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.13,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:25Z",
      "quality_category": "standard",
      "satellite_azimuth": 118.7,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:14Z",
      "view_angle": 13.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82623787544092,
            45.8440822428173
          ],
          [
            -84.82911567620766,
            45.83501806752589
          ],
          [
            -84.79817639538413,
            45.829786401676536
          ],
          [
            -84.79507962864596,
            45.838821727599026
          ],
          [
            -84.82623787544092,
            45.8440822428173
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0015",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.02,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:24Z",
      "quality_category": "standard",
      "satellite_azimuth": 112.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:13Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7920513623205,
            45.85938716004409
          ],
          [
            -84.79511359325669,
            45.850469941207294
          ],
          [
            -84.76385811769768,
            45.84503188829219
          ],
          [
            -84.7608189528729,
            45.85391957683689
          ],
          [
            -84.7920513623205,
            45.85938716004409
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0016",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.63,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:24Z",
      "quality_category": "standard",
      "satellite_azimuth": 117,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:13Z",
      "view_angle": 13.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7737415200852,
            45.82731170283321
          ],
          [
            -84.77679563556988,
            45.81834971691199
          ],
          [
            -84.74555484744188,
            45.81302414038482
          ],
          [
            -84.74245637579821,
            45.82199084244625
          ],
          [
            -84.7737415200852,
            45.82731170283321
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0016",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.23,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:24Z",
      "quality_category": "standard",
      "satellite_azimuth": 115.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.9,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:13Z",
      "view_angle": 13.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78925435529358,
            45.867081577523145
          ],
          [
            -84.79228973803691,
            45.858181274287155
          ],
          [
            -84.76101003485645,
            45.85280500746244
          ],
          [
            -84.75805482160645,
            45.86170706154875
          ],
          [
            -84.78925435529358,
            45.867081577523145
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0015",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.99,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:23Z",
      "quality_category": "standard",
      "satellite_azimuth": 114.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:12Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77144666302576,
            45.835173674582585
          ],
          [
            -84.7744540519274,
            45.82627652117761
          ],
          [
            -84.74332244358034,
            45.8208861829234
          ],
          [
            -84.74029794465798,
            45.82977318854061
          ],
          [
            -84.77144666302576,
            45.835173674582585
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0015",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.21,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:23Z",
      "quality_category": "standard",
      "satellite_azimuth": 112.9,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:12Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82358893902446,
            45.851934784175434
          ],
          [
            -84.82653519726848,
            45.84289301360455
          ],
          [
            -84.79539253842906,
            45.83772218661709
          ],
          [
            -84.79228215641068,
            45.846736277699826
          ],
          [
            -84.82358893902446,
            45.851934784175434
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0014",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.02,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:22Z",
      "quality_category": "standard",
      "satellite_azimuth": 109.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:11Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78658069920432,
            45.87491128236253
          ],
          [
            -84.78954233199984,
            45.86600256128372
          ],
          [
            -84.75830041334942,
            45.860712802492884
          ],
          [
            -84.75539681888506,
            45.86961861050803
          ],
          [
            -84.78658069920432,
            45.87491128236253
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0014",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.04,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:22Z",
      "quality_category": "standard",
      "satellite_azimuth": 111.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:11Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7682964866188,
            45.8429931494131
          ],
          [
            -84.77133181018034,
            45.83405293613744
          ],
          [
            -84.74019020140562,
            45.82880156612303
          ],
          [
            -84.73721269957606,
            45.83772023652998
          ],
          [
            -84.7682964866188,
            45.8429931494131
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0014",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.28,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:22Z",
      "quality_category": "standard",
      "satellite_azimuth": 109.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:11Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82095761539425,
            45.8596706124188
          ],
          [
            -84.82400154684017,
            45.85071533857453
          ],
          [
            -84.79268331608202,
            45.84561353279694
          ],
          [
            -84.7895903822788,
            45.854557981441445
          ],
          [
            -84.82095761539425,
            45.8596706124188
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0013",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.06,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:21Z",
      "quality_category": "standard",
      "satellite_azimuth": 106.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:10Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78398205403981,
            45.882702175010024
          ],
          [
            -84.78696472748744,
            45.8738064223642
          ],
          [
            -84.7557309640582,
            45.86859822618555
          ],
          [
            -84.75279855420587,
            45.87748897669207
          ],
          [
            -84.78398205403981,
            45.882702175010024
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0013",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:21Z",
      "quality_category": "standard",
      "satellite_azimuth": 108.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:10Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76564219859488,
            45.8508665295874
          ],
          [
            -84.76869186815549,
            45.84196199935512
          ],
          [
            -84.73758588642228,
            45.83678020946923
          ],
          [
            -84.73460315472092,
            45.84566973390738
          ],
          [
            -84.76564219859488,
            45.8508665295874
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0013",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.76,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:21Z",
      "quality_category": "standard",
      "satellite_azimuth": 106.7,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:09Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.81841015140917,
            45.867465256123985
          ],
          [
            -84.82153992359596,
            45.858523068265406
          ],
          [
            -84.79009828720234,
            45.85340107000393
          ],
          [
            -84.7870691665575,
            45.86234179319196
          ],
          [
            -84.81841015140917,
            45.867465256123985
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0012",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.24,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:20Z",
      "quality_category": "standard",
      "satellite_azimuth": 103.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:09Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7815074418228,
            45.89050168223527
          ],
          [
            -84.7844886049543,
            45.88160616753963
          ],
          [
            -84.75326401547784,
            45.8764795636905
          ],
          [
            -84.75024665353666,
            45.885346192788454
          ],
          [
            -84.7815074418228,
            45.89050168223527
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0012",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:20Z",
      "quality_category": "standard",
      "satellite_azimuth": 105,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:08Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.81589764772156,
            45.875250058117366
          ],
          [
            -84.81897891950167,
            45.86631887152349
          ],
          [
            -84.78756680574953,
            45.861290356503034
          ],
          [
            -84.78458912205986,
            45.87024317286618
          ],
          [
            -84.81589764772156,
            45.875250058117366
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0011",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.17,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:19Z",
      "quality_category": "standard",
      "satellite_azimuth": 100.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:08Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77901526439074,
            45.89836071193855
          ],
          [
            -84.78198918232455,
            45.889465810404985
          ],
          [
            -84.75067521626819,
            45.884398669845126
          ],
          [
            -84.7478063125744,
            45.89329370753896
          ],
          [
            -84.77901526439074,
            45.89836071193855
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0011",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.64,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:19Z",
      "quality_category": "standard",
      "satellite_azimuth": 101.9,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:07Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76309215435373,
            45.85873229801525
          ],
          [
            -84.76616040497537,
            45.84983810401957
          ],
          [
            -84.73507383127516,
            45.84472798499622
          ],
          [
            -84.73196532582475,
            45.853599245790924
          ],
          [
            -84.76309215435373,
            45.85873229801525
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0012",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.95,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:19Z",
      "quality_category": "standard",
      "satellite_azimuth": 103.5,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:08Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.81344857936317,
            45.88307895359144
          ],
          [
            -84.81643309990872,
            45.874122826946966
          ],
          [
            -84.78508835947522,
            45.86918945465531
          ],
          [
            -84.78208592965635,
            45.87812632118738
          ],
          [
            -84.81344857936317,
            45.88307895359144
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0010",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:18Z",
      "quality_category": "standard",
      "satellite_azimuth": 97.3,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:06Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76062180254831,
            45.866669805740564
          ],
          [
            -84.76359205684052,
            45.85775573162071
          ],
          [
            -84.73245150603425,
            45.852709959039956
          ],
          [
            -84.72941282947882,
            45.86158994523565
          ],
          [
            -84.76062180254831,
            45.866669805740564
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0011",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.99,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:18Z",
      "quality_category": "standard",
      "satellite_azimuth": 100.3,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:07Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.81083066174516,
            45.89083998963401
          ],
          [
            -84.81387763865685,
            45.88188718971222
          ],
          [
            -84.78247816564026,
            45.877014075743105
          ],
          [
            -84.77946578206227,
            45.88595734214821
          ],
          [
            -84.81083066174516,
            45.89083998963401
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0009",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:17Z",
      "quality_category": "standard",
      "satellite_azimuth": 94.3,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:05Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77651330819683,
            45.90623764161212
          ],
          [
            -84.7795007742274,
            45.89734043727084
          ],
          [
            -84.74823292211374,
            45.89235741696196
          ],
          [
            -84.74519420000114,
            45.901231536942255
          ],
          [
            -84.77651330819683,
            45.90623764161212
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0010",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.99,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:17Z",
      "quality_category": "standard",
      "satellite_azimuth": 98.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:06Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75815142025263,
            45.874608411666976
          ],
          [
            -84.76112589315916,
            45.8656928237571
          ],
          [
            -84.72986655710632,
            45.86070108349646
          ],
          [
            -84.72698717545116,
            45.869606708524095
          ],
          [
            -84.75815142025263,
            45.874608411666976
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0010",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:17Z",
      "quality_category": "standard",
      "satellite_azimuth": 97.2,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:06Z",
      "view_angle": 13.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77390166911573,
            45.91407289010139
          ],
          [
            -84.77688747978135,
            45.90516783209495
          ],
          [
            -84.74552649797701,
            45.90024878485924
          ],
          [
            -84.74262183777904,
            45.9091455270443
          ],
          [
            -84.77390166911573,
            45.91407289010139
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0009",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 1,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:16Z",
      "quality_category": "standard",
      "satellite_azimuth": 95.7,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:05Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75551833917314,
            45.88248369516842
          ],
          [
            -84.75852389382962,
            45.87356486462204
          ],
          [
            -84.72731832660375,
            45.86865342252675
          ],
          [
            -84.7242860693376,
            45.87754807873299
          ],
          [
            -84.75551833917314,
            45.88248369516842
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0009",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.97,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:16Z",
      "quality_category": "standard",
      "satellite_azimuth": 94.1,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:04Z",
      "view_angle": 13.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80824745382372,
            45.89862845988043
          ],
          [
            -84.81119717464375,
            45.88966176846904
          ],
          [
            -84.779797466721,
            45.88485317625792
          ],
          [
            -84.77678434101107,
            45.893808974359196
          ],
          [
            -84.80824745382372,
            45.89862845988043
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0008",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 1,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:15Z",
      "quality_category": "standard",
      "satellite_azimuth": 91.3,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:04Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d2_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77122087847972,
            45.9219382476933
          ],
          [
            -84.7742071557592,
            45.913022788948254
          ],
          [
            -84.74286664278527,
            45.908180642112114
          ],
          [
            -84.73994278929193,
            45.917084371088286
          ],
          [
            -84.77122087847972,
            45.9219382476933
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d2_0008",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d2",
      "cloud_cover": 0.99,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:15Z",
      "quality_category": "standard",
      "satellite_azimuth": 92.6,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:04Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80568248179972,
            45.90639945791492
          ],
          [
            -84.80863266105375,
            45.89742947990697
          ],
          [
            -84.7771824567828,
            45.89268756174101
          ],
          [
            -84.77417713566676,
            45.901653782969746
          ],
          [
            -84.80568248179972,
            45.90639945791492
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0007",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 1,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:14Z",
      "quality_category": "standard",
      "satellite_azimuth": 88.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:03Z",
      "view_angle": 13.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75282296408909,
            45.890379699064546
          ],
          [
            -84.75583288555957,
            45.88144737841343
          ],
          [
            -84.72455377977926,
            45.87660147063852
          ],
          [
            -84.7215576276267,
            45.885517459586815
          ],
          [
            -84.75282296408909,
            45.890379699064546
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0008",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.99,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:14Z",
      "quality_category": "standard",
      "satellite_azimuth": 91,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:03Z",
      "view_angle": 13.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0006",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0006/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0006/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80325891661741,
            45.91412453803366
          ],
          [
            -84.80627902437712,
            45.90514796686906
          ],
          [
            -84.77471911568283,
            45.900480776326134
          ],
          [
            -84.77172087959784,
            45.90944818629918
          ],
          [
            -84.80325891661741,
            45.91412453803366
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0006",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 1,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:13Z",
      "quality_category": "standard",
      "satellite_azimuth": 85.6,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:02Z",
      "view_angle": 13.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75017715190546,
            45.89827275679712
          ],
          [
            -84.7531866326749,
            45.88932556200843
          ],
          [
            -84.72188188284943,
            45.88455013324117
          ],
          [
            -84.71885782908348,
            45.893479776965044
          ],
          [
            -84.75017715190546,
            45.89827275679712
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0007",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.86,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:13Z",
      "quality_category": "standard",
      "satellite_azimuth": 88,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:02Z",
      "view_angle": 13.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0005",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0005/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d3_0005/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.80082324794108,
            45.921901565092746
          ],
          [
            -84.80383727920602,
            45.91291528771847
          ],
          [
            -84.77223354617215,
            45.90831412351112
          ],
          [
            -84.76923724756101,
            45.917291419615665
          ],
          [
            -84.80082324794108,
            45.921901565092746
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d3_0005",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d3",
      "cloud_cover": 0.99,
      "ground_control": false,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:12Z",
      "quality_category": "standard",
      "satellite_azimuth": 82.8,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.7,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:00Z",
      "view_angle": 14.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0006",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0006/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0006/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74757297413579,
            45.90613095722357
          ],
          [
            -84.75069989402584,
            45.897165980100915
          ],
          [
            -84.71932169174296,
            45.89245638838009
          ],
          [
            -84.7162937484336,
            45.901402006040215
          ],
          [
            -84.74757297413579,
            45.90613095722357
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0006",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.6,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:12Z",
      "quality_category": "standard",
      "satellite_azimuth": 85,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:03:01Z",
      "view_angle": 13.8
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0005",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0005/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0005/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74512736113111,
            45.91403167127391
          ],
          [
            -84.74809544434424,
            45.90505925161935
          ],
          [
            -84.71670525592023,
            45.90041323784584
          ],
          [
            -84.71367853784297,
            45.90937978552766
          ],
          [
            -84.74512736113111,
            45.91403167127391
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0005",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.46,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:11Z",
      "quality_category": "standard",
      "satellite_azimuth": 82.2,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:02:59Z",
      "view_angle": 14.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180418_191031_ssc10d1_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74260970901537,
            45.92202736832012
          ],
          [
            -84.74562947785824,
            45.91303628135655
          ],
          [
            -84.71413329409759,
            45.90845856329988
          ],
          [
            -84.71110330903787,
            45.91744002118792
          ],
          [
            -84.74260970901537,
            45.92202736832012
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180418_191031_ssc10d1_0004",
    "properties": {
      "acquired": "2018-04-18T19:10:31.821Z",
      "camera_id": "d1",
      "cloud_cover": 0.69,
      "ground_control": true,
      "gsd": 0.8,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:27:10Z",
      "quality_category": "standard",
      "satellite_azimuth": 79.4,
      "satellite_id": "SSC10",
      "strip_id": "s110_20180418T191031Z",
      "sun_azimuth": 216.8,
      "sun_elevation": 50,
      "updated": "2018-06-22T19:02:58Z",
      "view_angle": 14.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0020",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0020/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0020/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73282383621603,
            45.802294422128696
          ],
          [
            -84.73618474472771,
            45.791764231169076
          ],
          [
            -84.69915551227469,
            45.78619225558776
          ],
          [
            -84.69571854784225,
            45.7967165081216
          ],
          [
            -84.73282383621603,
            45.802294422128696
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0020",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:07Z",
      "quality_category": "test",
      "satellite_azimuth": 273.6,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:52Z",
      "view_angle": 14.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0019",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0019/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0019/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73003085199696,
            45.81039087185152
          ],
          [
            -84.73340196604238,
            45.799910206796696
          ],
          [
            -84.69648131234094,
            45.79429712645699
          ],
          [
            -84.69314966045602,
            45.80476140507719
          ],
          [
            -84.73003085199696,
            45.81039087185152
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0019",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:06Z",
      "quality_category": "test",
      "satellite_azimuth": 274.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:51Z",
      "view_angle": 14.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0018",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0018/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0018/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72645865787555,
            45.8196156250622
          ],
          [
            -84.72993817655333,
            45.80907286189433
          ],
          [
            -84.69275567920415,
            45.803449250137895
          ],
          [
            -84.68925634235916,
            45.81399949502931
          ],
          [
            -84.72645865787555,
            45.8196156250622
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0018",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:05Z",
      "quality_category": "test",
      "satellite_azimuth": 275.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:50Z",
      "view_angle": 14.6
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7690633525536,
            45.80095224305706
          ],
          [
            -84.77245975547282,
            45.790478830997806
          ],
          [
            -84.73567093743429,
            45.78478740090452
          ],
          [
            -84.7322217687595,
            45.795272467390674
          ],
          [
            -84.7690633525536,
            45.80095224305706
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0017",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:04Z",
      "quality_category": "test",
      "satellite_azimuth": 277.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:49Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72311841420338,
            45.82860390338649
          ],
          [
            -84.72660911827377,
            45.818133484127905
          ],
          [
            -84.68960253721981,
            45.81247635673373
          ],
          [
            -84.68611819337725,
            45.82294578847338
          ],
          [
            -84.72311841420338,
            45.82860390338649
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0017",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:04Z",
      "quality_category": "test",
      "satellite_azimuth": 276.6,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:49Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76612785081959,
            45.81011346118404
          ],
          [
            -84.76951609375685,
            45.79960726524012
          ],
          [
            -84.73269413615951,
            45.793878126223845
          ],
          [
            -84.72923743215685,
            45.80439382872479
          ],
          [
            -84.76612785081959,
            45.81011346118404
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0016",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:03Z",
      "quality_category": "test",
      "satellite_azimuth": 278.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:48Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72070092576215,
            45.837677818387725
          ],
          [
            -84.7240828797389,
            45.827314430777996
          ],
          [
            -84.68720589110993,
            45.82168551411187
          ],
          [
            -84.68366567119352,
            45.83198388059475
          ],
          [
            -84.72070092576215,
            45.837677818387725
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0016",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:03Z",
      "quality_category": "test",
      "satellite_azimuth": 277.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:48Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76319398920698,
            45.81952759261963
          ],
          [
            -84.76658029689727,
            45.80896007447585
          ],
          [
            -84.7296677015403,
            45.80319322871661
          ],
          [
            -84.72616052865258,
            45.81376770877578
          ],
          [
            -84.76319398920698,
            45.81952759261963
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0015",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:02Z",
      "quality_category": "test",
      "satellite_azimuth": 279.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:47Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71763381455446,
            45.84694412879939
          ],
          [
            -84.72106030073498,
            45.83650495673698
          ],
          [
            -84.68420823306252,
            45.83081556043161
          ],
          [
            -84.68082233450029,
            45.841245552796146
          ],
          [
            -84.71763381455446,
            45.84694412879939
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0015",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:02Z",
      "quality_category": "test",
      "satellite_azimuth": 278.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:46Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69683907169158,
            45.798986244644375
          ],
          [
            -84.70025399277745,
            45.788551057707565
          ],
          [
            -84.66347931071444,
            45.782800068775984
          ],
          [
            -84.66011013540522,
            45.793217106192515
          ],
          [
            -84.69683907169158,
            45.798986244644375
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d1_0016",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:02Z",
      "quality_category": "test",
      "satellite_azimuth": 279,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:47Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76005409622871,
            45.82867724335485
          ],
          [
            -84.76317668610741,
            45.818225494781345
          ],
          [
            -84.7258395545305,
            45.812375632650095
          ],
          [
            -84.72271001484275,
            45.822835237783686
          ],
          [
            -84.76005409622871,
            45.82867724335485
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0014",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:01Z",
      "quality_category": "test",
      "satellite_azimuth": 280.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:46Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69371764621528,
            45.80820312732895
          ],
          [
            -84.69709594691375,
            45.79774930661717
          ],
          [
            -84.65992123113178,
            45.79189010727671
          ],
          [
            -84.656574233387,
            45.80236148728129
          ],
          [
            -84.69371764621528,
            45.80820312732895
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d1_0015",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:01Z",
      "quality_category": "test",
      "satellite_azimuth": 279.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:46Z",
      "view_angle": 14.5
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71484699657715,
            45.85622046177392
          ],
          [
            -84.71815920557319,
            45.845789493736355
          ],
          [
            -84.68119360916752,
            45.84005823695827
          ],
          [
            -84.67788431441976,
            45.85050735689972
          ],
          [
            -84.71484699657715,
            45.85622046177392
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0014",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0.02,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:00Z",
      "quality_category": "test",
      "satellite_azimuth": 279.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:45Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d1_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.68981317158998,
            45.817341069773406
          ],
          [
            -84.69297383786545,
            45.806891981899966
          ],
          [
            -84.65530798880687,
            45.800949363539864
          ],
          [
            -84.65214031743051,
            45.81140628110216
          ],
          [
            -84.68981317158998,
            45.817341069773406
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d1_0014",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:17:00Z",
      "quality_category": "test",
      "satellite_azimuth": 280.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56.1,
      "updated": "2018-06-22T18:56:45Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75722667400298,
            45.83785231077682
          ],
          [
            -84.76057058605787,
            45.82737753690379
          ],
          [
            -84.72385506460337,
            45.821634217506585
          ],
          [
            -84.72061663561001,
            45.83204995535514
          ],
          [
            -84.75722667400298,
            45.83785231077682
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0013",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:59Z",
      "quality_category": "test",
      "satellite_azimuth": 281.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:44Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7118643806237,
            45.865426326099346
          ],
          [
            -84.71534975011848,
            45.85503273300668
          ],
          [
            -84.67836122411676,
            45.8492558314126
          ],
          [
            -84.67502901856199,
            45.85969070299398
          ],
          [
            -84.7118643806237,
            45.865426326099346
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0013",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:59Z",
      "quality_category": "test",
      "satellite_azimuth": 280.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:44Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75434836118777,
            45.8470349465393
          ],
          [
            -84.75777783512339,
            45.83659678276124
          ],
          [
            -84.72099610146012,
            45.830727286950186
          ],
          [
            -84.71761799518589,
            45.84117811386487
          ],
          [
            -84.75434836118777,
            45.8470349465393
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0012",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:58Z",
      "quality_category": "test",
      "satellite_azimuth": 282.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:43Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70901183064582,
            45.87455292711871
          ],
          [
            -84.71239410648658,
            45.86414807696747
          ],
          [
            -84.67553553233819,
            45.85835762941774
          ],
          [
            -84.67217614691278,
            45.86878194047871
          ],
          [
            -84.70901183064582,
            45.87455292711871
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0012",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:58Z",
      "quality_category": "test",
      "satellite_azimuth": 281.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:43Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75156431408391,
            45.85608833365912
          ],
          [
            -84.7549218686132,
            45.84564931068638
          ],
          [
            -84.71818145767898,
            45.839742907425105
          ],
          [
            -84.7148334204894,
            45.85019655655249
          ],
          [
            -84.75156431408391,
            45.85608833365912
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0011",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0.02,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:57Z",
      "quality_category": "test",
      "satellite_azimuth": 283.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:42Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70625386089785,
            45.883360204092654
          ],
          [
            -84.70960659146333,
            45.87296861819792
          ],
          [
            -84.67294697451425,
            45.86712411427763
          ],
          [
            -84.6696385917154,
            45.87753354581307
          ],
          [
            -84.70625386089785,
            45.883360204092654
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0011",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:57Z",
      "quality_category": "test",
      "satellite_azimuth": 282.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:42Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74855112210274,
            45.86547007517307
          ],
          [
            -84.7519283047113,
            45.85503672528406
          ],
          [
            -84.7151741131157,
            45.84908623506031
          ],
          [
            -84.71178947164351,
            45.859532007380004
          ],
          [
            -84.74855112210274,
            45.86547007517307
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0010",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0.09,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:56Z",
      "quality_category": "test",
      "satellite_azimuth": 284.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:41Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74530769654066,
            45.87478904180683
          ],
          [
            -84.7488655634253,
            45.864392788533536
          ],
          [
            -84.71210199526166,
            45.85840070296832
          ],
          [
            -84.70860843018427,
            45.86882087746497
          ],
          [
            -84.74530769654066,
            45.87478904180683
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0009",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0.08,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:55Z",
      "quality_category": "test",
      "satellite_azimuth": 285.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:40Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70344614127254,
            45.89300657584787
          ],
          [
            -84.70676622484889,
            45.88249742079589
          ],
          [
            -84.66989621096684,
            45.876611723993115
          ],
          [
            -84.66656922940695,
            45.8871286828562
          ],
          [
            -84.70344614127254,
            45.89300657584787
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0010",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:55Z",
      "quality_category": "test",
      "satellite_azimuth": 283.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:40Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69935791011214,
            45.90210503768424
          ],
          [
            -84.70290896596984,
            45.89165466420332
          ],
          [
            -84.66607352333493,
            45.88573243899521
          ],
          [
            -84.66251488678357,
            45.89620852997992
          ],
          [
            -84.69935791011214,
            45.90210503768424
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0009",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:54Z",
      "quality_category": "test",
      "satellite_azimuth": 284.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:39Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74238701156737,
            45.88377261181733
          ],
          [
            -84.74571655501212,
            45.873326493947154
          ],
          [
            -84.70901314221544,
            45.867305886906884
          ],
          [
            -84.70558658801062,
            45.87774171530572
          ],
          [
            -84.74238701156737,
            45.88377261181733
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0008",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:49Z",
      "quality_category": "test",
      "satellite_azimuth": 286.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:39Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69672784271987,
            45.91114275018748
          ],
          [
            -84.70017809778663,
            45.90066343935935
          ],
          [
            -84.66351623625111,
            45.89477090050521
          ],
          [
            -84.6600587743541,
            45.905266973444974
          ],
          [
            -84.69672784271987,
            45.91114275018748
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0008",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:48Z",
      "quality_category": "test",
      "satellite_azimuth": 285.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:38Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73936790227471,
            45.89279255173299
          ],
          [
            -84.74290502827573,
            45.88238349664776
          ],
          [
            -84.70609027766918,
            45.87630002005628
          ],
          [
            -84.70265659535724,
            45.886748876811616
          ],
          [
            -84.73936790227471,
            45.89279255173299
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0007",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:47Z",
      "quality_category": "test",
      "satellite_azimuth": 287.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:37Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d2_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69374970275635,
            45.92015536190523
          ],
          [
            -84.6972143953155,
            45.909667444087596
          ],
          [
            -84.66056138447141,
            45.903738145888816
          ],
          [
            -84.65708986084816,
            45.914233828395545
          ],
          [
            -84.69374970275635,
            45.92015536190523
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d2_0007",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:47Z",
      "quality_category": "test",
      "satellite_azimuth": 286.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.3,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:37Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0006",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0006/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0006/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73636859749205,
            45.90180341099927
          ],
          [
            -84.73982132999772,
            45.8913638540189
          ],
          [
            -84.70309740542483,
            45.88527042990745
          ],
          [
            -84.699655124948,
            45.89573588538606
          ],
          [
            -84.73636859749205,
            45.90180341099927
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0006",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:46Z",
      "quality_category": "test",
      "satellite_azimuth": 289,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:36Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0005",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0005/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0005/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73328130189589,
            45.91087720722654
          ],
          [
            -84.73671584821673,
            45.90040868532703
          ],
          [
            -84.70000008371825,
            45.89428377417525
          ],
          [
            -84.69653959570178,
            45.90477407778394
          ],
          [
            -84.73328130189589,
            45.91087720722654
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0005",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:40Z",
      "quality_category": "test",
      "satellite_azimuth": 290,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:35Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180421_172201_ss01d3_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73011154350625,
            45.919948834817866
          ],
          [
            -84.73353031795443,
            45.90952248023968
          ],
          [
            -84.69674888798566,
            45.903309218043965
          ],
          [
            -84.69335463366693,
            45.913769133330355
          ],
          [
            -84.73011154350625,
            45.919948834817866
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180421_172201_ss01d3_0004",
    "properties": {
      "acquired": "2018-04-21T17:22:01.071Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:16:38Z",
      "quality_category": "test",
      "satellite_azimuth": 291,
      "satellite_id": "SS01",
      "strip_id": "s1_20180421T172201Z",
      "sun_azimuth": 173.2,
      "sun_elevation": 56,
      "updated": "2018-06-22T18:56:33Z",
      "view_angle": 14.4
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0019",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0019/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0019/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73143269393884,
            45.80553073335823
          ],
          [
            -84.73492673871912,
            45.7949250175898
          ],
          [
            -84.69522720355401,
            45.789191603980576
          ],
          [
            -84.69175078086097,
            45.80019454772613
          ],
          [
            -84.73143269393884,
            45.80553073335823
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0019",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:20Z",
      "quality_category": "test",
      "satellite_azimuth": 276.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.5,
      "updated": "2018-06-22T18:49:16Z",
      "view_angle": 18.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0018",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0018/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0018/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72853605717162,
            45.81506654066706
          ],
          [
            -84.73199754944527,
            45.80431633035373
          ],
          [
            -84.69332106704911,
            45.79848319886502
          ],
          [
            -84.6898518361863,
            45.80925009765102
          ],
          [
            -84.72853605717162,
            45.81506654066706
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0018",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:19Z",
      "quality_category": "test",
      "satellite_azimuth": 277.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:15Z",
      "view_angle": 18.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77248332832214,
            45.79613141241571
          ],
          [
            -84.77600214278408,
            45.78544766750581
          ],
          [
            -84.73760012701003,
            45.779534186680934
          ],
          [
            -84.73404768111935,
            45.79022883299504
          ],
          [
            -84.77248332832214,
            45.79613141241571
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0017",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:18Z",
      "quality_category": "test",
      "satellite_azimuth": 279.2,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.5,
      "updated": "2018-06-22T18:49:14Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76935559854697,
            45.805617285665264
          ],
          [
            -84.77286181857765,
            45.79491006573494
          ],
          [
            -84.73445921318432,
            45.78895069018546
          ],
          [
            -84.73090363483446,
            45.7996661323144
          ],
          [
            -84.76935559854697,
            45.805617285665264
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0016",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:17Z",
      "quality_category": "test",
      "satellite_azimuth": 280,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:13Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0017",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0017/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0017/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72458305918241,
            45.82425869797113
          ],
          [
            -84.72823666887253,
            45.813566447623394
          ],
          [
            -84.68950505428245,
            45.8076769350274
          ],
          [
            -84.68583052380258,
            45.81839454045441
          ],
          [
            -84.72458305918241,
            45.82425869797113
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0017",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:17Z",
      "quality_category": "test",
      "satellite_azimuth": 278.2,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:14Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76613707175277,
            45.8150161399589
          ],
          [
            -84.76958777430379,
            45.80435459402446
          ],
          [
            -84.73117459649683,
            45.798278416749085
          ],
          [
            -84.72771665873776,
            45.80894767467218
          ],
          [
            -84.76613707175277,
            45.8150161399589
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0015",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:16Z",
      "quality_category": "test",
      "satellite_azimuth": 280.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:12Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72132750731498,
            45.83368064438122
          ],
          [
            -84.72499565290387,
            45.82297980061861
          ],
          [
            -84.68625942162296,
            45.817053105707075
          ],
          [
            -84.68257071999463,
            45.82777030559143
          ],
          [
            -84.72132750731498,
            45.83368064438122
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0016",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:16Z",
      "quality_category": "test",
      "satellite_azimuth": 278.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:13Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0016",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0016/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0016/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69660842060381,
            45.793968113585905
          ],
          [
            -84.70028937159267,
            45.783313261770346
          ],
          [
            -84.66130744636202,
            45.77721106348538
          ],
          [
            -84.65761918363303,
            45.7878735253315
          ],
          [
            -84.69660842060381,
            45.793968113585905
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d1_0016",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:16Z",
      "quality_category": "test",
      "satellite_azimuth": 280.1,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.5,
      "updated": "2018-06-22T18:49:12Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71900192825233,
            45.843052521174435
          ],
          [
            -84.722487812835,
            45.83234105726357
          ],
          [
            -84.68409086593081,
            45.82646664619866
          ],
          [
            -84.6805549413122,
            45.83714788003105
          ],
          [
            -84.71900192825233,
            45.843052521174435
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0015",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:15Z",
      "quality_category": "test",
      "satellite_azimuth": 279.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:11Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0015",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0015/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0015/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.6938447096551,
            45.80325522670965
          ],
          [
            -84.69733439416291,
            45.79258762014096
          ],
          [
            -84.6585297536641,
            45.78640705413086
          ],
          [
            -84.65503276147395,
            45.79708234164717
          ],
          [
            -84.6938447096551,
            45.80325522670965
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d1_0015",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:15Z",
      "quality_category": "test",
      "satellite_azimuth": 280.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.5,
      "updated": "2018-06-22T18:49:11Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76303924284835,
            45.824226346866304
          ],
          [
            -84.76635149082583,
            45.8135171960962
          ],
          [
            -84.72747424677776,
            45.80731369924315
          ],
          [
            -84.72415426477505,
            45.81803958627729
          ],
          [
            -84.76303924284835,
            45.824226346866304
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0014",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:14Z",
      "quality_category": "test",
      "satellite_azimuth": 281.6,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:11Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71597458454978,
            45.852277301136
          ],
          [
            -84.71923799213538,
            45.84161330527263
          ],
          [
            -84.68021694985357,
            45.835478835604384
          ],
          [
            -84.67697729651576,
            45.84626980054177
          ],
          [
            -84.71597458454978,
            45.852277301136
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0014",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:14Z",
      "quality_category": "test",
      "satellite_azimuth": 280.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:10Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0014",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0014/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d1_0014/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.68986979411451,
            45.81223874058716
          ],
          [
            -84.69322127865505,
            45.80152347257668
          ],
          [
            -84.6539526834081,
            45.79522398081063
          ],
          [
            -84.65059375779488,
            45.805946960580926
          ],
          [
            -84.68986979411451,
            45.81223874058716
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d1_0014",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d1",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:14Z",
      "quality_category": "test",
      "satellite_azimuth": 281.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:10Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75958297557585,
            45.833357420765644
          ],
          [
            -84.76301298445486,
            45.822632688674176
          ],
          [
            -84.72434409902738,
            45.81654023089907
          ],
          [
            -84.72095747867425,
            45.82729168606391
          ],
          [
            -84.75958297557585,
            45.833357420765644
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0013",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:13Z",
      "quality_category": "test",
      "satellite_azimuth": 282.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:10Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0013",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0013/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71255864759733,
            45.861385716729856
          ],
          [
            -84.71613854086476,
            45.85078666460181
          ],
          [
            -84.67741131108941,
            45.844735375245804
          ],
          [
            -84.67403297129188,
            45.855410151936454
          ],
          [
            -84.71255864759733,
            45.861385716729856
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0013",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:13Z",
      "quality_category": "test",
      "satellite_azimuth": 281.3,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:09Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75625589307975,
            45.84290449104946
          ],
          [
            -84.75971917337978,
            45.83224789848292
          ],
          [
            -84.72143961916724,
            45.826149800143604
          ],
          [
            -84.71792295368736,
            45.83678931338162
          ],
          [
            -84.75625589307975,
            45.84290449104946
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0012",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:12Z",
      "quality_category": "test",
      "satellite_azimuth": 283.2,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:08Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0012",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0012/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70923222949074,
            45.87085555826819
          ],
          [
            -84.71274246330645,
            45.86025331469902
          ],
          [
            -84.67417133836958,
            45.85418715228731
          ],
          [
            -84.67076939365575,
            45.864832164586566
          ],
          [
            -84.70923222949074,
            45.87085555826819
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0012",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:12Z",
      "quality_category": "test",
      "satellite_azimuth": 282.1,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:08Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75307487194786,
            45.85247858478456
          ],
          [
            -84.75652110690193,
            45.841826315179965
          ],
          [
            -84.7182069936282,
            45.83565271974447
          ],
          [
            -84.71475452556848,
            45.84631254723473
          ],
          [
            -84.75307487194786,
            45.85247858478456
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0011",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:11Z",
      "quality_category": "test",
      "satellite_azimuth": 284,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:07Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75011715123371,
            45.86209015715963
          ],
          [
            -84.75349369666824,
            45.85143013970555
          ],
          [
            -84.71519001997487,
            45.84519927438733
          ],
          [
            -84.7117920228331,
            45.855868393402
          ],
          [
            -84.75011715123371,
            45.86209015715963
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0010",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:10Z",
      "quality_category": "test",
      "satellite_azimuth": 284.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:06Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0011",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0011/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70641731752947,
            45.8822022085522
          ],
          [
            -84.70974479376459,
            45.870160633309595
          ],
          [
            -84.6704327697871,
            45.863870361428205
          ],
          [
            -84.66538267112217,
            45.875579188695305
          ],
          [
            -84.70641731752947,
            45.8822022085522
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0011",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:10Z",
      "quality_category": "test",
      "satellite_azimuth": 282.9,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:07Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0010",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0010/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.70369248701574,
            45.890158296815
          ],
          [
            -84.70697082235195,
            45.8794052720563
          ],
          [
            -84.66849116665165,
            45.87323476616901
          ],
          [
            -84.6651926016195,
            45.88399529052961
          ],
          [
            -84.70369248701574,
            45.890158296815
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0010",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:09Z",
      "quality_category": "test",
      "satellite_azimuth": 283.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:05Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74726176440632,
            45.87167076404025
          ],
          [
            -84.75079549913956,
            45.861041249960586
          ],
          [
            -84.71251681845186,
            45.85476422930059
          ],
          [
            -84.70893341637938,
            45.86539530740606
          ],
          [
            -84.74726176440632,
            45.87167076404025
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0009",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0.02,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:08Z",
      "quality_category": "test",
      "satellite_azimuth": 285.7,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:05Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0009",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0009/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69991762452437,
            45.89947909955265
          ],
          [
            -84.70345264482393,
            45.8887853626117
          ],
          [
            -84.66503249948678,
            45.88258790026779
          ],
          [
            -84.66148983166467,
            45.893298309777634
          ],
          [
            -84.69991762452437,
            45.89947909955265
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0009",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:08Z",
      "quality_category": "test",
      "satellite_azimuth": 284.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:04Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74479155808471,
            45.88126159444164
          ],
          [
            -84.74816683534522,
            45.870598563000925
          ],
          [
            -84.70986051186213,
            45.86426374012664
          ],
          [
            -84.70636093604794,
            45.87491641871194
          ],
          [
            -84.74479155808471,
            45.88126159444164
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0008",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:07Z",
      "quality_category": "test",
      "satellite_azimuth": 286.5,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:04Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69713998281458,
            45.908972889076814
          ],
          [
            -84.70071447732231,
            45.89828904722726
          ],
          [
            -84.66251921884333,
            45.89211328327204
          ],
          [
            -84.65892424535248,
            45.90281352823536
          ],
          [
            -84.69713998281458,
            45.908972889076814
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0008",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:07Z",
      "quality_category": "test",
      "satellite_azimuth": 285.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.3,
      "updated": "2018-06-22T18:49:03Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74220156747549,
            45.89087668728797
          ],
          [
            -84.7457614332457,
            45.88024660142917
          ],
          [
            -84.70742211321293,
            45.87385142205222
          ],
          [
            -84.7039208987471,
            45.88451164050985
          ],
          [
            -84.74220156747549,
            45.89087668728797
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0007",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:06Z",
      "quality_category": "test",
      "satellite_azimuth": 287.4,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:02Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d2_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.6949852523778,
            45.9186591856147
          ],
          [
            -84.69848467174678,
            45.90794691034826
          ],
          [
            -84.66028537234843,
            45.90171632923675
          ],
          [
            -84.65677832630585,
            45.912445296151944
          ],
          [
            -84.6949852523778,
            45.9186591856147
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d2_0007",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d2",
      "cloud_cover": 0,
      "ground_control": false,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:06Z",
      "quality_category": "test",
      "satellite_azimuth": 286.2,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.3,
      "sun_elevation": 56.3,
      "updated": "2018-06-22T18:49:02Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0006",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0006/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0006/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73961287567265,
            45.900506890347664
          ],
          [
            -84.74313082595661,
            45.8898677521928
          ],
          [
            -84.70486009048349,
            45.88343842138987
          ],
          [
            -84.70136191163283,
            45.89410691938054
          ],
          [
            -84.73961287567265,
            45.900506890347664
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0006",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:05Z",
      "quality_category": "test",
      "satellite_azimuth": 288.2,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.4,
      "updated": "2018-06-22T18:49:01Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0005",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0005/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0005/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73669159690515,
            45.910103661361035
          ],
          [
            -84.74020522185164,
            45.89946202658551
          ],
          [
            -84.70199775462856,
            45.89298707289663
          ],
          [
            -84.69851439969342,
            45.903651439189055
          ],
          [
            -84.73669159690515,
            45.910103661361035
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0005",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0.01,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:04Z",
      "quality_category": "test",
      "satellite_azimuth": 289,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.3,
      "updated": "2018-06-22T18:49:00Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.73334840404017,
            45.91966466784777
          ],
          [
            -84.736832077354,
            45.90902301439335
          ],
          [
            -84.69847036740826,
            45.90246401460429
          ],
          [
            -84.6949787737958,
            45.91315924770262
          ],
          [
            -84.73334840404017,
            45.91966466784777
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0004",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:03Z",
      "quality_category": "test",
      "satellite_azimuth": 289.8,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.3,
      "updated": "2018-06-22T18:48:59Z",
      "view_angle": 18
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0003",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0003/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20180422_172411_ss01d3_0003/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.72983549109577,
            45.9288083773354
          ],
          [
            -84.73329455904681,
            45.91814873448044
          ],
          [
            -84.69491991891357,
            45.91157464218186
          ],
          [
            -84.69142456723215,
            45.92228220623353
          ],
          [
            -84.72983549109577,
            45.9288083773354
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180422_172411_ss01d3_0003",
    "properties": {
      "acquired": "2018-04-22T17:24:11.502Z",
      "camera_id": "d3",
      "cloud_cover": 0,
      "ground_control": true,
      "gsd": 0.9,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2018-06-19T23:11:01Z",
      "quality_category": "test",
      "satellite_azimuth": 290.6,
      "satellite_id": "SS01",
      "strip_id": "s1_20180422T172411Z",
      "sun_azimuth": 174.2,
      "sun_elevation": 56.3,
      "updated": "2018-06-22T18:48:57Z",
      "view_angle": 18.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660222_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660222_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660222_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180602_163715_1660222_RapidEye-1",
    "properties": {
      "acquired": "2018-06-02T16:37:15Z",
      "anomalous_pixels": 0,
      "black_fill": 0,
      "catalog_id": "36287287",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-06-03T08:32:57Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "36287203",
      "sun_azimuth": 147.61043,
      "sun_elevation": 63.6592,
      "updated": "2018-06-03T08:32:57Z",
      "usable_data": 1,
      "view_angle": 9.5509
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660221_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660221_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180602_163715_1660221_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.88227146741536,
            45.930379350450664
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -84.95388572084974,
            45.70662472548464
          ],
          [
            -84.8979108831221,
            45.8817370750352
          ],
          [
            -84.88227146741536,
            45.930379350450664
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180602_163715_1660221_RapidEye-1",
    "properties": {
      "acquired": "2018-06-02T16:37:15Z",
      "anomalous_pixels": 0.74,
      "black_fill": 0.74,
      "catalog_id": "36287286",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-06-03T08:32:57Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "36287203",
      "sun_azimuth": 147.03416,
      "sun_elevation": 63.53853,
      "updated": "2018-06-03T08:32:57Z",
      "usable_data": 0.26,
      "view_angle": 9.5509
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164327_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164327_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164327_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.65705833862528,
            45.70091673365054
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.57505631373553,
            45.92426780188677
          ],
          [
            -84.5967471333736,
            45.8655149869242
          ],
          [
            -84.65705833862528,
            45.70091673365054
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180507_164327_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-05-07T16:43:27Z",
      "anomalous_pixels": 0.3,
      "black_fill": 0.3,
      "catalog_id": "36060353",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-05-10T10:42:48Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36060301",
      "sun_azimuth": 155.12425,
      "sun_elevation": 59.33954,
      "updated": "2018-05-10T10:42:48Z",
      "usable_data": 0.7,
      "view_angle": -2.9618
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164328_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164328_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180507_164328_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180507_164328_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-05-07T16:43:28Z",
      "anomalous_pixels": 0,
      "black_fill": 0,
      "catalog_id": "36060352",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-05-10T10:42:20Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "36060301",
      "sun_azimuth": 154.58319,
      "sun_elevation": 59.24326,
      "updated": "2018-05-10T10:42:20Z",
      "usable_data": 1,
      "view_angle": -2.9618
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180319_164230_1660222_RapidEye-2",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180319_164230_1660222_RapidEye-2/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180319_164230_1660222_RapidEye-2/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.77642907730946,
            45.928361191171916
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.84606154199649,
            45.70474411353166
          ],
          [
            -84.8261466505733,
            45.7690022128344
          ],
          [
            -84.77642907730946,
            45.928361191171916
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180319_164230_1660222_RapidEye-2",
    "properties": {
      "acquired": "2018-03-19T16:42:30Z",
      "anomalous_pixels": 0.61,
      "black_fill": 0.11,
      "catalog_id": "35575401",
      "cloud_cover": 0.5,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-03-21T05:57:29Z",
      "rows": 5000,
      "satellite_id": "RapidEye-2",
      "strip_id": "35575280",
      "sun_azimuth": 158.28886,
      "sun_elevation": 41.87534,
      "updated": "2018-03-21T05:57:29Z",
      "usable_data": 0.39,
      "view_angle": 10.45327
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.63181575504558,
            45.70040556265016
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.56182387172176,
            45.92399882044462
          ],
          [
            -84.6013478173406,
            45.7981190907262
          ],
          [
            -84.63181575504558,
            45.70040556265016
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180320_163423_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-03-20T16:34:23Z",
      "anomalous_pixels": 0.67,
      "black_fill": 0.24,
      "catalog_id": "35582860",
      "cloud_cover": 0.43,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-03-21T05:47:17Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "35582803",
      "sun_azimuth": 155.61884,
      "sun_elevation": 41.71739,
      "updated": "2018-03-21T05:47:17Z",
      "usable_data": 0.33,
      "view_angle": 16.9597
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180320_163423_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180320_163423_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-03-20T16:34:23Z",
      "anomalous_pixels": 0.63,
      "black_fill": 0,
      "catalog_id": "35582859",
      "cloud_cover": 0.63,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-03-21T05:47:17Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "35582803",
      "sun_azimuth": 155.22822,
      "sun_elevation": 41.62288,
      "updated": "2018-03-21T05:47:17Z",
      "usable_data": 0.37,
      "view_angle": 16.9597
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180316_164942_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-03-16T16:49:42Z",
      "anomalous_pixels": 0.67,
      "black_fill": 0,
      "catalog_id": "35548666",
      "cloud_cover": 0.67,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-03-21T04:23:32Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "35548554",
      "sun_azimuth": 160.72295,
      "sun_elevation": 41.11433,
      "updated": "2018-03-21T04:23:32Z",
      "usable_data": 0.33,
      "view_angle": -9.69268
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180316_164942_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180316_164942_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-03-16T16:49:42Z",
      "anomalous_pixels": 0.79,
      "black_fill": 0,
      "catalog_id": "35548665",
      "cloud_cover": 0.79,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-03-21T04:23:32Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "35548554",
      "sun_azimuth": 160.32997,
      "sun_elevation": 41.03746,
      "updated": "2018-03-21T04:23:32Z",
      "usable_data": 0.21,
      "view_angle": -9.69268
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164502_1660222_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164502_1660222_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164502_1660222_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.55238518393574,
            45.698797066262856
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.52330517225256,
            45.789344540616696
          ],
          [
            -84.55238518393574,
            45.698797066262856
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180106_164502_1660222_RapidEye-1",
    "properties": {
      "acquired": "2018-01-06T16:45:02Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0.02,
      "catalog_id": "34902029",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-07T08:05:24Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "34901994",
      "sun_azimuth": 165.28673,
      "sun_elevation": 20.60123,
      "updated": "2018-01-07T08:05:24Z",
      "usable_data": 0.98,
      "view_angle": 16.12941
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164503_1660221_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164503_1660221_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180106_164503_1660221_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180106_164503_1660221_RapidEye-1",
    "properties": {
      "acquired": "2018-01-06T16:45:03Z",
      "anomalous_pixels": 0,
      "black_fill": 0,
      "catalog_id": "34902028",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-07T07:57:39Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "34901994",
      "sun_azimuth": 164.99033,
      "sun_elevation": 20.54058,
      "updated": "2018-01-07T07:57:39Z",
      "usable_data": 1,
      "view_angle": 16.12941
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180104_165536_1660222_RapidEye-3",
    "properties": {
      "acquired": "2018-01-04T16:55:36Z",
      "anomalous_pixels": 0,
      "black_fill": 0,
      "catalog_id": "34873598",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-05T09:15:45Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "34873561",
      "sun_azimuth": 168.1107,
      "sun_elevation": 20.8342,
      "updated": "2018-01-05T09:15:45Z",
      "usable_data": 1,
      "view_angle": -12.8832
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20180104_165536_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1561055096158,
            45.717957442350446
          ],
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.10437442656439,
            45.7092655049906
          ],
          [
            -85.1561055096158,
            45.717957442350446
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20180104_165536_1660221_RapidEye-3",
    "properties": {
      "acquired": "2018-01-04T16:55:36Z",
      "anomalous_pixels": 0.01,
      "black_fill": 0.01,
      "catalog_id": "34873597",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-05T09:11:51Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "34873561",
      "sun_azimuth": 167.81316,
      "sun_elevation": 20.78389,
      "updated": "2018-01-05T09:11:51Z",
      "usable_data": 0.99,
      "view_angle": -12.8832
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165249_1660221_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165249_1660221_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165249_1660221_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.0559961054217,
            45.933439574224415
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1406748146816,
            45.70990250509331
          ],
          [
            -85.1252967209817,
            45.7507604103802
          ],
          [
            -85.0559961054217,
            45.933439574224415
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171231_165249_1660221_RapidEye-4",
    "properties": {
      "acquired": "2017-12-31T16:52:49Z",
      "anomalous_pixels": 0.36,
      "black_fill": 0.17,
      "catalog_id": "34834685",
      "cloud_cover": 0.19,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-01T12:34:11Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "34834592",
      "sun_azimuth": 167.64897,
      "sun_elevation": 20.38046,
      "updated": "2018-01-01T12:34:11Z",
      "usable_data": 0.64,
      "view_angle": -12.94256
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165248_1660222_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165248_1660222_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171231_165248_1660222_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171231_165248_1660222_RapidEye-4",
    "properties": {
      "acquired": "2017-12-31T16:52:48Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0,
      "catalog_id": "34834686",
      "cloud_cover": 0.02,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2018-01-01T12:34:11Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "34834592",
      "sun_azimuth": 167.94505,
      "sun_elevation": 20.43141,
      "updated": "2018-01-01T12:34:11Z",
      "usable_data": 0.98,
      "view_angle": -12.94256
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660222_RapidEye-5",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660222_RapidEye-5/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660222_RapidEye-5/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171227_165117_1660222_RapidEye-5",
    "properties": {
      "acquired": "2017-12-27T16:51:17Z",
      "anomalous_pixels": 0.04,
      "black_fill": 0,
      "catalog_id": "34787961",
      "cloud_cover": 0.04,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-28T11:36:31Z",
      "rows": 5000,
      "satellite_id": "RapidEye-5",
      "strip_id": "34787870",
      "sun_azimuth": 168.08747,
      "sun_elevation": 20.19902,
      "updated": "2017-12-28T11:36:31Z",
      "usable_data": 0.96,
      "view_angle": -6.26109
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660221_RapidEye-5",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660221_RapidEye-5/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171227_165117_1660221_RapidEye-5/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.03564892644836,
            45.93308115113867
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.11612070091437,
            45.70947162890154
          ],
          [
            -85.0497767048884,
            45.8940384228525
          ],
          [
            -85.03564892644836,
            45.93308115113867
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171227_165117_1660221_RapidEye-5",
    "properties": {
      "acquired": "2017-12-27T16:51:17Z",
      "anomalous_pixels": 0.24,
      "black_fill": 0.24,
      "catalog_id": "34787960",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-28T11:36:31Z",
      "rows": 5000,
      "satellite_id": "RapidEye-5",
      "strip_id": "34787870",
      "sun_azimuth": 167.79215,
      "sun_elevation": 20.14856,
      "updated": "2017-12-28T11:36:31Z",
      "usable_data": 0.76,
      "view_angle": -6.26109
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171225_164530_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171225_164530_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171225_164530_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79457666871401,
            45.92873008493336
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.84533014259785,
            45.77972677792098
          ],
          [
            -84.79457666871401,
            45.92873008493336
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171225_164530_1660222_RapidEye-3",
    "properties": {
      "acquired": "2017-12-25T16:45:30Z",
      "anomalous_pixels": 0.96,
      "black_fill": 0.05,
      "catalog_id": "34762615",
      "cloud_cover": 0.91,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-26T10:17:59Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "34762530",
      "sun_azimuth": 166.9457,
      "sun_elevation": 19.94017,
      "updated": "2017-12-26T10:17:59Z",
      "usable_data": 0.04,
      "view_angle": 0.3386
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0008",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0008/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0008/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79414218439142,
            45.797622835250664
          ],
          [
            -84.79523806676221,
            45.784611658183195
          ],
          [
            -84.74586499475824,
            45.786390156490654
          ],
          [
            -84.74478489438607,
            45.799365713932666
          ],
          [
            -84.79414218439142,
            45.797622835250664
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0008",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.42,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:37Z",
      "quality_category": "test",
      "satellite_azimuth": 68,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 68,
      "sun_elevation": 58.7,
      "updated": "2018-06-08T03:10:12Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0007",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0007/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0007/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.7933366852275,
            45.8089006773917
          ],
          [
            -84.79443639641352,
            45.79585188520118
          ],
          [
            -84.74493384845348,
            45.79773537074893
          ],
          [
            -84.74385050098628,
            45.810748229343865
          ],
          [
            -84.7933366852275,
            45.8089006773917
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0007",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.64,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:37Z",
      "quality_category": "test",
      "satellite_azimuth": 67.5,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 67.5,
      "sun_elevation": 58.5,
      "updated": "2018-06-08T03:10:11Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0006",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0006/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0006/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79294401613176,
            45.81994090545187
          ],
          [
            -84.79404745771237,
            45.80685322238768
          ],
          [
            -84.74441133456423,
            45.80884391763063
          ],
          [
            -84.74332484519043,
            45.82189533979464
          ],
          [
            -84.79294401613176,
            45.81994090545187
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0006",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.51,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:36Z",
      "quality_category": "test",
      "satellite_azimuth": 67,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 67,
      "sun_elevation": 58.4,
      "updated": "2018-06-08T03:10:11Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0005",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0005/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0005/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.79171010287173,
            45.83013069316952
          ],
          [
            -84.79281803350088,
            45.817005891665346
          ],
          [
            -84.74305894218351,
            45.819097048533735
          ],
          [
            -84.7419685292488,
            45.832185282040605
          ],
          [
            -84.79171010287173,
            45.83013069316952
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0005",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.65,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:36Z",
      "quality_category": "test",
      "satellite_azimuth": 66.5,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 66.5,
      "sun_elevation": 58.2,
      "updated": "2018-06-08T03:10:10Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83768255997887,
            45.79703605550165
          ],
          [
            -84.83883512059101,
            45.78377922730929
          ],
          [
            -84.78867871975041,
            45.786096992489014
          ],
          [
            -84.78754274064552,
            45.79931752615883
          ],
          [
            -84.83768255997887,
            45.79703605550165
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d3_0004",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d3",
      "cloud_cover": 0.84,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 65.5,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 65.5,
      "sun_elevation": 57.6,
      "updated": "2018-06-08T03:10:10Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0003",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0003/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0003/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.837652356402,
            45.807107278562746
          ],
          [
            -84.83880865155311,
            45.79380991790178
          ],
          [
            -84.78851705008154,
            45.796234609278955
          ],
          [
            -84.78737790564853,
            45.809495337391745
          ],
          [
            -84.837652356402,
            45.807107278562746
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d3_0003",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d3",
      "cloud_cover": 0.76,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 65.1,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 65.1,
      "sun_elevation": 57.5,
      "updated": "2018-06-08T03:10:09Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78941811546665,
            45.8408919749683
          ],
          [
            -84.79053034658031,
            45.827730651565524
          ],
          [
            -84.74065310702609,
            45.82992044445922
          ],
          [
            -84.73955894849799,
            45.84304490129006
          ],
          [
            -84.78941811546665,
            45.8408919749683
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0004",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.52,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 66,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 66,
      "sun_elevation": 58,
      "updated": "2018-06-08T03:10:10Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0003",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0003/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0003/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78925786021044,
            45.851183462752914
          ],
          [
            -84.79037311013654,
            45.83798311701057
          ],
          [
            -84.74036416582089,
            45.84027804388096
          ],
          [
            -84.73908214809286,
            45.85350005564127
          ],
          [
            -84.78925786021044,
            45.851183462752914
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0003",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.51,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 65.6,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 65.6,
      "sun_elevation": 57.9,
      "updated": "2018-06-08T03:10:09Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0004",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0004/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74843731522269,
            45.80121321091532
          ],
          [
            -84.7495593821246,
            45.78802040317809
          ],
          [
            -84.69993305069232,
            45.79025975929383
          ],
          [
            -84.69882957983602,
            45.80341471481873
          ],
          [
            -84.74843731522269,
            45.80121321091532
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d1_0004",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d1",
      "cloud_cover": 0.52,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 65.2,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 65.2,
      "sun_elevation": 58.1,
      "updated": "2018-06-08T03:10:10Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0003",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0003/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0003/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74816815501131,
            45.811474341953335
          ],
          [
            -84.74929294243533,
            45.798241603699545
          ],
          [
            -84.69953453042592,
            45.80058619997817
          ],
          [
            -84.69842890079917,
            45.813780745690295
          ],
          [
            -84.74816815501131,
            45.811474341953335
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d1_0003",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d1",
      "cloud_cover": 0.69,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:35Z",
      "quality_category": "test",
      "satellite_azimuth": 64.7,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 64.7,
      "sun_elevation": 57.9,
      "updated": "2018-06-08T03:10:09Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0002",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0002/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83693499251652,
            45.81789450321968
          ],
          [
            -84.83809540376265,
            45.80455403641407
          ],
          [
            -84.78766300912626,
            45.80709149051722
          ],
          [
            -84.78652035134894,
            45.82039496775997
          ],
          [
            -84.83693499251652,
            45.81789450321968
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d3_0002",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d3",
      "cloud_cover": 0.42,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:34Z",
      "quality_category": "test",
      "satellite_azimuth": 64.6,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 64.6,
      "sun_elevation": 57.3,
      "updated": "2018-06-08T03:10:09Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0001",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0001/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d3_0001/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83616954816763,
            45.82852292568014
          ],
          [
            -84.83733337660364,
            45.81513849484294
          ],
          [
            -84.78675856357235,
            45.81779119127149
          ],
          [
            -84.78561309314551,
            45.8311382665327
          ],
          [
            -84.83616954816763,
            45.82852292568014
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d3_0001",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d3",
      "cloud_cover": 0.03,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:34Z",
      "quality_category": "test",
      "satellite_azimuth": 64.1,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 64.1,
      "sun_elevation": 57.1,
      "updated": "2018-06-08T03:10:08Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0002",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0002/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78818157394944,
            45.86227565425384
          ],
          [
            -84.7895224987794,
            45.84896236460072
          ],
          [
            -84.73931095848972,
            45.851389662107515
          ],
          [
            -84.73801130304362,
            45.86465865190787
          ],
          [
            -84.78818157394944,
            45.86227565425384
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0002",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.61,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:34Z",
      "quality_category": "test",
      "satellite_azimuth": 65.1,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 65.1,
      "sun_elevation": 57.7,
      "updated": "2018-06-08T03:10:09Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0001",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0001/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d2_0001/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.78746648982253,
            45.87308298286054
          ],
          [
            -84.78841063260003,
            45.85985750370647
          ],
          [
            -84.73805166688909,
            45.86240183942692
          ],
          [
            -84.73719924954456,
            45.87556496941262
          ],
          [
            -84.78746648982253,
            45.87308298286054
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d2_0001",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d2",
      "cloud_cover": 0.05,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:34Z",
      "quality_category": "test",
      "satellite_azimuth": 64.6,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 64.6,
      "sun_elevation": 57.5,
      "updated": "2018-06-08T03:10:08Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0002",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0002/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74720192409927,
            45.822461824739065
          ],
          [
            -84.74832975398994,
            45.80918663213134
          ],
          [
            -84.69843376513168,
            45.81164220412218
          ],
          [
            -84.69732568777181,
            45.82487884479339
          ],
          [
            -84.74720192409927,
            45.822461824739065
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d1_0002",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d1",
      "cloud_cover": 0.5,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:34Z",
      "quality_category": "test",
      "satellite_azimuth": 64.3,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 64.3,
      "sun_elevation": 57.8,
      "updated": "2018-06-08T03:10:08Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0001",
      "assets": "https://api.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0001/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/SkySatScene/items/20171224_193455_ss02d1_0001/thumb"
    },
    "_permissions": [
      "assets.basic_panchromatic_dn:download",
      "assets.ortho_analytic_dn:download",
      "assets.basic_analytic_dn_rpc:download",
      "assets.ortho_visual:download",
      "assets.ortho_analytic_udm:download",
      "assets.basic_panchromatic_dn_rpc:download",
      "assets.ortho_panchromatic_udm:download",
      "assets.ortho_pansharpened:download",
      "assets.ortho_pansharpened_udm:download",
      "assets.basic_analytic_dn:download",
      "assets.ortho_panchromatic_dn:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.74618474575452,
            45.83329491783869
          ],
          [
            -84.74731491616656,
            45.81997641048129
          ],
          [
            -84.69727976107856,
            45.822545397398315
          ],
          [
            -84.69616993951682,
            45.83582498438493
          ],
          [
            -84.74618474575452,
            45.83329491783869
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171224_193455_ss02d1_0001",
    "properties": {
      "acquired": "2017-12-24T19:34:55Z",
      "camera_id": "d1",
      "cloud_cover": 0.02,
      "ground_control": false,
      "gsd": 1.2,
      "item_type": "SkySatScene",
      "provider": "skysat",
      "published": "2017-12-25T08:38:33Z",
      "quality_category": "test",
      "satellite_azimuth": 63.8,
      "satellite_id": "SS02",
      "strip_id": "s2_20171224T193455Z",
      "sun_azimuth": 63.8,
      "sun_elevation": 57.6,
      "updated": "2018-06-08T03:10:07Z",
      "view_angle": 27.7
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165542_1660221_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165542_1660221_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165542_1660221_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171216_165542_1660221_RapidEye-3",
    "properties": {
      "acquired": "2017-12-16T16:55:42Z",
      "anomalous_pixels": 0.62,
      "black_fill": 0,
      "catalog_id": "34639836",
      "cloud_cover": 0.62,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-17T11:57:24Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "34639754",
      "sun_azimuth": 170.18452,
      "sun_elevation": 20.43328,
      "updated": "2017-12-17T11:57:24Z",
      "usable_data": 0.38,
      "view_angle": -12.98476
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165541_1660222_RapidEye-3",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165541_1660222_RapidEye-3/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171216_165541_1660222_RapidEye-3/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171216_165541_1660222_RapidEye-3",
    "properties": {
      "acquired": "2017-12-16T16:55:41Z",
      "anomalous_pixels": 0.74,
      "black_fill": 0,
      "catalog_id": "34639837",
      "cloud_cover": 0.74,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-17T11:57:24Z",
      "rows": 5000,
      "satellite_id": "RapidEye-3",
      "strip_id": "34639754",
      "sun_azimuth": 170.48156,
      "sun_elevation": 20.47497,
      "updated": "2017-12-17T11:57:24Z",
      "usable_data": 0.26,
      "view_angle": -12.98476
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660222_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660222_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660222_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171212_165249_1660222_RapidEye-4",
    "properties": {
      "acquired": "2017-12-12T16:52:49Z",
      "anomalous_pixels": 0.71,
      "black_fill": 0,
      "catalog_id": "34594292",
      "cloud_cover": 0.71,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-13T08:58:51Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "34594244",
      "sun_azimuth": 170.21729,
      "sun_elevation": 20.66286,
      "updated": "2017-12-13T08:58:51Z",
      "usable_data": 0.29,
      "view_angle": -9.64806
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660221_RapidEye-4",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660221_RapidEye-4/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171212_165249_1660221_RapidEye-4/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.1489221,
            45.9350765
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1563629,
            45.7101778
          ],
          [
            -85.1489221,
            45.9350765
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171212_165249_1660221_RapidEye-4",
    "properties": {
      "acquired": "2017-12-12T16:52:49Z",
      "anomalous_pixels": 0.28,
      "black_fill": 0,
      "catalog_id": "34594291",
      "cloud_cover": 0.28,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-12-13T08:57:06Z",
      "rows": 5000,
      "satellite_id": "RapidEye-4",
      "strip_id": "34594244",
      "sun_azimuth": 169.91946,
      "sun_elevation": 20.62018,
      "updated": "2017-12-13T08:57:06Z",
      "usable_data": 0.72,
      "view_angle": -9.64806
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164516_1660221_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164516_1660221_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164516_1660221_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.05369281899871,
            45.93339900098189
          ],
          [
            -84.8266524,
            45.9293996
          ],
          [
            -84.8353866,
            45.7045453
          ],
          [
            -85.1211694766579,
            45.70956022494236
          ],
          [
            -85.0744679139006,
            45.8647455240394
          ],
          [
            -85.05369281899871,
            45.93339900098189
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171129_164516_1660221_RapidEye-1",
    "properties": {
      "acquired": "2017-11-29T16:45:16Z",
      "anomalous_pixels": 0.21,
      "black_fill": 0.21,
      "catalog_id": "34449886",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-11-30T09:20:19Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "34449827",
      "sun_azimuth": 169.17576,
      "sun_elevation": 22.07574,
      "updated": "2017-11-30T09:20:19Z",
      "usable_data": 0.79,
      "view_angle": 15.99525
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164515_1660222_RapidEye-1",
      "assets": "https://api.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164515_1660222_RapidEye-1/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/REOrthoTile/items/20171129_164515_1660222_RapidEye-1/thumb"
    },
    "_permissions": [
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8395413,
            45.9296441
          ],
          [
            -84.5173706,
            45.9230952
          ],
          [
            -84.5273453,
            45.69829
          ],
          [
            -84.8482238,
            45.7047879
          ],
          [
            -84.8395413,
            45.9296441
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "20171129_164515_1660222_RapidEye-1",
    "properties": {
      "acquired": "2017-11-29T16:45:15Z",
      "anomalous_pixels": 0,
      "black_fill": 0,
      "catalog_id": "34449887",
      "cloud_cover": 0,
      "columns": 5000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 6.5,
      "item_type": "REOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 5,
      "provider": "rapideye",
      "published": "2017-11-30T09:20:19Z",
      "rows": 5000,
      "satellite_id": "RapidEye-1",
      "strip_id": "34449827",
      "sun_azimuth": 169.48009,
      "sun_elevation": 22.1212,
      "updated": "2017-11-30T09:20:19Z",
      "usable_data": 1,
      "view_angle": 15.99525
    },
    "type": "Feature"
  }
]

export default features



// WEBPACK FOOTER //
// ./src/config/plusPlusFeatures.js